import { gql } from "@apollo/client";

export const GET_BROWSER_CALL_ICE_SERVERS = gql`
  query getBrowserCallIceServers {
    getBrowserCallIceServers {
      urls
      username
      credential
    }
  }
`;

export const GET_BROWSER_CALL_ROOM = gql`
  query getBrowserCallRoom($roomId: String!) {
    getBrowserCallRoom(roomId: $roomId) {
      roomId
      status
      mediaMode
      customerName
      agentDisplayName
      businessName
      linkExpiresAt
      iceServers {
        urls
        username
        credential
      }
    }
  }
`;

export const GET_ACTIVE_BROWSER_CALL = gql`
  query getActiveBrowserCall {
    getActiveBrowserCall {
      id
      roomId
      inboxId
      agentId
      mainSuperAdminId
      channel
      mediaMode
      status
      customerName
      customerIdentifier
      linkExpiresAt
      ringingAt
      startedAt
      endedAt
      durationSeconds
      endReason
      recordingUrl
    }
  }
`;

export const GET_PENDING_INCOMING_BROWSER_CALLS = gql`
  query getPendingIncomingBrowserCalls {
    getPendingIncomingBrowserCalls {
      roomId
      sdpOffer
      customerName
      customerIdentifier
      channel
      mediaMode
      inboxId
    }
  }
`;

export const GET_MY_BROWSER_CALLS = gql`
  query getMyBrowserCalls($limit: Int, $offset: Int) {
    getMyBrowserCalls(limit: $limit, offset: $offset) {
      id
      roomId
      channel
      mediaMode
      status
      customerName
      customerIdentifier
      linkExpiresAt
      startedAt
      endedAt
      durationSeconds
      endReason
      recordingUrl
      createdAt
    }
  }
`;
